import { Navigate, Route, Routes } from 'react-router-dom';

import { HomePage } from '@/pages/HomePage/HomePage';
import { PositionsStartPage } from '@/pages/PositionsStartPage/PositionsStartPage';
import { PositionsTopicsPage } from '@/pages/PositionsTopicsPage/PositionsTopicsPage';
import { PositionsQuestionPage } from '@/pages/PositionsQuestionPage/PositionsQuestionPage';
import { PositionsProcessingPage } from '@/pages/PositionsProcessingPage/PositionsProcessingPage';
import { PositionsSummaryPage } from '@/pages/PositionsSummaryPage/PositionsSummaryPage';
import { MatchPoliticoSharePage } from '@/pages/MatchPoliticoSharePage/MatchPoliticoSharePage';
import { MatchPoliticoCandidatePage } from '@/pages/MatchPoliticoCandidatePage/MatchPoliticoCandidatePage';
import { TopicProposalsPage } from '@/pages/TopicProposalsPage/TopicProposalsPage';
import { ProposalSourcePage } from '@/pages/ProposalSourcePage/ProposalSourcePage';
import { CandidateProposalPage } from '@/pages/CandidateProposalPage/CandidateProposalPage';
import { MatchPoliticoMethodologyPage } from '@/pages/MatchPoliticoMethodologyPage/MatchPoliticoMethodologyPage';
import { TermsPage } from '@/pages/TermsPage/TermsPage';
import { PrivacyPolicyPage } from '@/pages/PrivacyPolicyPage/PrivacyPolicyPage';
import { PlaywrightHomePage } from '@/pages/PlaywrightHomePage/PlaywrightHomePage';

const enablePlaywrightHome = import.meta.env.VITE_PLAYWRIGHT_HOME_TEST === 'true';

export function AppRouter(): JSX.Element {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/share" element={<HomePage />} />
      <Route path="/match-politico" element={<PositionsStartPage />} />
      <Route path="/match-politico/temas" element={<PositionsTopicsPage />} />
      <Route path="/match-politico/perguntas" element={<PositionsQuestionPage />} />
      <Route path="/match-politico/processando" element={<PositionsProcessingPage />} />
      <Route path="/match-politico/resumo" element={<PositionsSummaryPage />} />
      <Route path="/match-politico/compartilhar" element={<MatchPoliticoSharePage />} />
      <Route path="/match-politico/detalhes/:candidateId" element={<MatchPoliticoCandidatePage />} />
      <Route path="/match-politico/tema/:topicId" element={<TopicProposalsPage />} />
      <Route path="/match-politico/tema/:topicId/candidato/:candidateId" element={<ProposalSourcePage />} />
      <Route path="/posicoes" element={<PositionsStartPage />} />
      <Route path="/posicoes/temas" element={<PositionsTopicsPage />} />
      <Route path="/posicoes/perguntas" element={<PositionsQuestionPage />} />
      <Route path="/posicoes/processando" element={<PositionsProcessingPage />} />
      <Route path="/posicoes/resumo" element={<PositionsSummaryPage />} />
      <Route path="/posicoes/compartilhar" element={<MatchPoliticoSharePage />} />
      <Route path="/posicoes/tema/:topicId" element={<TopicProposalsPage />} />
      <Route path="/posicoes/tema/:topicId/candidato/:candidateId" element={<ProposalSourcePage />} />
      <Route path="/proposta-candidato/:slug" element={<CandidateProposalPage />} />
      <Route path="/proposta-candidato/:slug/:topicSlug" element={<CandidateProposalPage />} />
      <Route path="/match-politico/metodologia" element={<MatchPoliticoMethodologyPage />} />
      <Route path="/termos" element={<TermsPage />} />
      <Route path="/privacidade" element={<PrivacyPolicyPage />} />
      {enablePlaywrightHome ? <Route path="/__playwright/home" element={<PlaywrightHomePage />} /> : null}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
